import { transformRepeatBet } from "../../services/UserGroup.js";
import { APP_CONFIG } from "../constants/global-variables.js";

export async function mybet(id) {
    const options = {
        method: "GET",
        credentials: "include",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
        },
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/mybet/${id}`;

    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });

        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

export async function repeatbetinfo(id) {
    const options = {
        method: "GET",
        credentials: "include",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
        },
    };

    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/repeatbetinfo/${id}`;

    try {
        const res = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
            },
        });
        return transformRepeatBet(res.data);
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}
